export default {
  'Choose File': 'Datei auswählen',
  'Please paste a URL': 'Bitte fügen eine URL ein',
  'Loading': 'Wird geladen',
  'Analyzing': 'Analysieren',
  'Try a sample': 'Probieren ein Beispiel',
  'Sorry, error occurs when analyzing the URL.': 'Bei der Analyse der URL tritt leider ein Fehler auf.',
  'Upload a photo': 'Ein Foto hochladen',
  "Drag and drop files to the upload box.": 'Ziehen & Tropfen Dateien in das Hochladen Feld.',
  'Please select the proper position with portrait.': 'Bitte wählen Sie die richtige Position mit Porträt.',
  'downloading': 'wird heruntergeladen',
}